import React, { createContext, useState, useEffect } from "react";

export const OrderContext = createContext();

export const OrderProvider = ({ children }) => {
    const [cartList, setCartQuantity] = useState(() => {
        // Initialize cartList from localStorage if available
        const storedCartList = localStorage.getItem("cartList");
        return storedCartList ? JSON.parse(storedCartList) : [];
    });
    const [checkout, setCheckOut] = useState(false);
    const [dbname, setDatabaseName] = useState('');
    const [hotelID, setHotelID] = useState('');
    const [propertyname, setPropertyName] = useState('');
    const [roomID, setRoomID] = useState('');
    const [guestName, setGuestName] = useState('');
    const [roomNo, setRoomNo] = useState('');
    const [encryptedURL, setEncryptedUrl] = useState('');
    const [OrderNo, setOrderNo] = useState('');
    const [outletID, setOutletID] = useState('0');
    const [tableNo, setTableNo] = useState('');
    const [homePage, setHomePage] = useState('');
    const [userCode, setUserCode] = useState('');

    const addProduct = (product) => {
        setCartQuantity((prev) => [...prev, product]);
        increase(product);
    };

    const removeProduct = (product) => {
        setCartQuantity((prev) => prev.filter((item) => item.id !== product.id));
    };

    const increase = (product) => {
        setCartQuantity((prev) =>
            prev.map((item) =>
                item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
            )
        );
    };

    const decrease = (product) => {
        setCartQuantity((prev) =>
            prev
                .map((item) =>
                    item.id === product.id
                        ? { ...item, quantity: item.quantity - 1 }
                        : item
                )
                .filter((item) => item.quantity > 0) // Remove items with quantity 0
        );
    };

    const ADDInstructions = (productId, instructions) => {
        setCartQuantity((prev) =>
            prev.map((item) =>
                item.id === productId
                    ? { ...item, instructions: instructions } // Update only the product with matching id
                    : item
            )
        );
    };

    // Calculate total price
    //const total = cartList.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const formattedTotal = cartList.reduce((sum, item) => {
        const price = parseFloat(item.price) || 0;
        const quantity = parseFloat(item.quantity) || 0;
        return sum + (price * quantity);
    }, 0);

    const total = Math.round(formattedTotal * 100) / 100;  // Ensures 2 decimal places

    // Calculate total item count
    const itemCount = cartList.reduce((sum, item) => sum + item.quantity, 0);


    // Sync cartList with localStorage
    useEffect(() => {
        localStorage.setItem("cartList", JSON.stringify(cartList));
    }, [cartList]);

    return (
        <OrderContext.Provider
            value={{
                total,
                itemCount,
                cartList,
                checkout,
                setCheckOut,
                addProduct,
                removeProduct,
                increase,
                decrease,
                ADDInstructions, // Expose ADDInstructions in the context
                setCartQuantity,
                setDatabaseName,
                setRoomID,
                setHotelID,
                setPropertyName,
                setGuestName,
                setRoomNo,
                setEncryptedUrl,
                setHomePage,
                setUserCode,
                setOutletID,
                encryptedURL,
                hotelID,
                dbname,
                roomID,
                tableNo,
                setOrderNo,
                setTableNo,
                OrderNo,
                roomNo,
                guestName,
                propertyname,
                homePage,
                userCode,
                outletID
            }}
        >
            {children}
        </OrderContext.Provider>
    );
};
